import {inject, injectable} from "inversify";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {Player} from "@/modules/team/entity";
import chance from "@/modules/base/services/chance";

@injectable()
export default class WageCalculator {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  calculate(player: Player): number {
    return chance.integer({min: 1, max: 5}) * 10;
  }
}
